<template>
    <fade-loader :loading="!value.loaded" :loaded="value.loaded">
        <div class="toolbox-content">
            <v-slide-x-transition mode="out-in">
                <recursive-help-list :entry="getHelpEntries"
                                     :parentChain="value.parentChain"
                                     @click="setActiveHelp($event)"
                                     @back="goBack"
                                     class="sr-helplist"
                                     :key="getHelpEntries.title"></recursive-help-list>
            </v-slide-x-transition>
        </div>
    </fade-loader>
</template>

<script>
  import RecursiveHelpList from '@/components/toolbox/help/RecursiveHelpList'

  export default {
    props: {
      value: {
        type: Object,
        required: true
      },
      errors: {
        type: Object,
        required: false
      },
      readOnly: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    components: { RecursiveHelpList },
    data () {
      return {
        activeEntry: null,
        parentChain: []
      }
    },
    methods: {
      setActiveHelp (item) {
        this.value.parentChain.push(this.getHelpEntries)
        this.value.activeEntry = item
      },
      goBack () {
        this.value.activeEntry = this.value.parentChain.pop()
      }
    },
    computed: {
      getHelpEntries () {
        return this.value.activeEntry ? this.value.activeEntry : this.value
      }
    }
  }
</script>

<style scoped>

</style>
